import { get } from 'helpers/api';

export const download = (file) => {
  // Attachments carry a `path` whose GET returns a fresh presigned downloadUrl. Project documents
  // (DocsTab) have no `path` -- their `url` is directly openable -- so open it instead of GET(undefined).
  if (!file.path) {
    window.open(file.url, '_blank');
    return;
  }

  get(file.path).then((refreshed) => {
    window.open(refreshed.downloadUrl, '_blank');
  });
};